<template>
	<div class="content-wrap">
		<template>
			<a-form-model
				layout="inline"
				:label-col="{ span: 8 }"
				:wrapper-col="{ span: 16 }"
				class="customer-list-form"
				:colon="false"
			>
				<a-form-model-item :label="$t('userList.name')">
					<a-auto-complete
						v-model.trim="params.condition.name"
						:placeholder="$t('userList.name')"
						size="small"
						:allowClear="true"
						:data-source="dataSourceName"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('userList.contactNumber')">
					<a-auto-complete
						v-model.trim="params.condition.mobile"
						:placeholder="$t('userList.contactNumber')"
						size="small"
						:allowClear="true"
						:data-source="dataSourceMobile"
						@change="onChangeSource"
					/>
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						@click="search"
						size="small"
						style="marginLeft:10px;"
					>
						{{ $t('search') }}
					</a-button>
				</a-form-model-item>
				<a-form-model-item>
					<a-button @click="resetSearch" size="small">
						{{ $t('reset') }}
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</template>

		<!-- table展示 -->
		<div class="table-area">
			<table-fixed
				:tableData="tableData"
				:tableColumn="columns"
				:columnSettingsKey="$route.name"
				:pagination="pagination"
				:loading="loading"
			></table-fixed>
		</div>
	</div>
</template>
<script>
import tableFixed from "../../components/table-fixed.vue";
import { userlist } from "../../api/basicData";
import { columns } from "./user-list";
import { searchReqParam } from "../../utils/searchReqParam";

export default {
	name: "business-dispatch",
	components: { tableFixed },
	data() {
		return {
			columns,
			req: searchReqParam(),
			tableData: [],
			params: {
				condition: {
					companyId: "",
					mobile: "",
					name: "",
				},
				page: 1,
				pageSize: 10,
			},
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			loading: false,
			dataSourceName: [],
			dataSourceMobile: [],
		};
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		pageInit() {
			this.req.params = this.params;
			this.loading = true;
			userlist(this.req).then((res) => {
				let resData = JSON.parse(res.data);
				if (!resData.success || resData.code != "0") {
					this.$message.error(resData.msg);
					return;
				}
				this.tableData = resData.data.list;
				this.pagination.total = resData.data.total;
				this.loading = false;
			});
		},
		// 搜索
		search() {
			this.pagination.onChange(1);
		},
		// 重置搜索
		resetSearch() {
			this.params.condition = {};
		},
		onChangeSource(searchText) {
			this.req.params = this.params;
			userlist(this.req).then((res) => {
				let temp = JSON.parse(res.data).data.list;

				// 姓名
				this.dataSourceName = [];
				temp.forEach((item) => {
					if (this.dataSourceName.indexOf(item.name) == -1) {
						this.dataSourceName.push(item.name);
					}
				});
				this.dataSourceName = !searchText ? [] : this.dataSourceName;

				// 电话
				this.dataSourceMobile = [];
				temp.forEach((item) => {
					if (this.dataSourceMobile.indexOf(item.mobile) == -1) {
						this.dataSourceMobile.push(item.mobile);
					}
				});
				this.dataSourceMobile = !searchText ? [] : this.dataSourceMobile;
			});
		},
	},
};
</script>

<style lang="less" scoped></style>
